interface FilterControlsProps {
  categories: string[];
  locations: string[];
  selectedCategory: string;
  selectedLocation: string;
  priceRange: string;
  onCategoryChange: (category: string) => void;
  onLocationChange: (location: string) => void;
  onPriceRangeChange: (price: string) => void;
}

const FilterControls = ({
  categories,
  locations,
  selectedCategory,
  selectedLocation,
  priceRange,
  onCategoryChange,
  onLocationChange,
  onPriceRangeChange,
}: FilterControlsProps) => {
  return (
    <div className="bg-gray-50 rounded-xl sm:rounded-2xl border border-gray-200 p-4 sm:p-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
        {/* Category Filter */}
        <div>
          <label className="flex items-center text-xs sm:text-sm font-semibold text-gray-900 mb-2 sm:mb-3">
            <i className="ri-grid-line mr-2 text-teal-600"></i>
            Category
          </label>
          <select
            value={selectedCategory}
            onChange={(e) => onCategoryChange(e.target.value)}
            className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white border border-gray-300 rounded-lg text-xs sm:text-sm text-gray-900 focus:outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20 transition-all cursor-pointer"
          >
            {categories.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>

        {/* Location Filter */}
        <div>
          <label className="flex items-center text-xs sm:text-sm font-semibold text-gray-900 mb-2 sm:mb-3">
            <i className="ri-map-pin-line mr-2 text-teal-600"></i>
            Location
          </label>
          <select
            value={selectedLocation}
            onChange={(e) => onLocationChange(e.target.value)}
            className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white border border-gray-300 rounded-lg text-xs sm:text-sm text-gray-900 focus:outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20 transition-all cursor-pointer"
          >
            {locations.map((location) => (
              <option key={location} value={location}>
                {location}
              </option>
            ))}
          </select>
        </div>

        {/* Price Filter */}
        <div>
          <label className="flex items-center text-xs sm:text-sm font-semibold text-gray-900 mb-2 sm:mb-3">
            <i className="ri-price-tag-3-line mr-2 text-teal-600"></i>
            Price
          </label>
          <select
            value={priceRange}
            onChange={(e) => onPriceRangeChange(e.target.value)}
            className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white border border-gray-300 rounded-lg text-xs sm:text-sm text-gray-900 focus:outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20 transition-all cursor-pointer"
          >
            <option value="All">All Prices</option>
            <option value="Free">Free</option>
            <option value="Paid">Paid</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterControls;
